import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';
/** Thin key shared by realtime, without importing editor/SDK into startup. */
export const macroLibraryKey = () => ['macros', sessionScope(useAuthStore.getState())] as const;
